<template>
  <content-loading v-if="isLoading" />
  <div v-else-if="stage" class="rm--card" :class="stageClass" :style="customStyle">
    <div class="rm--card-header">
      <div class="rm--title">{{ title }}</div>
      <radial-progress-bar
        :diameter="46"
        :completed-steps="completedStepsCount"
        :total-steps="totalStepsCount"
        innerStrokeColor="#E8EAED"
        startColor="#FF7C48"
        stopColor="#FF7C48"
        :strokeWidth="4"
        :innerStrokeWidth="4"
      >
        <div class="rm--progress-text">{{ totalStepsCount + "/" + completedStepsCount }}</div>
      </radial-progress-bar>
    </div>
    <hr class="my-1" />
    <div class="rm--card-body">
      <div class="rm--text mb-4 text-justify">
        {{ stage.description | translate }}
      </div>
      <h6 v-if="stage.tasks && stage.tasks.length > 0" class="rm-h6">{{ $t("task.plural") }}</h6>

      <div v-if="stage.tasks !== undefined">
        <div v-if="stage.status == 'UNAVAILABLE'">
          <div
            v-for="task in stage.tasks"
            :key="roadmapDefinition + task._id"
            :class="task.status == 'DONE' ? 'done' : ''"
            class="rm--task text-muted mb-1"
            style="cursor:not-allowed"
          >
            <i :class="task.status == 'DONE' ? 'iconoir-check-circle' : 'iconoir-circle'"></i>
            {{ task.name | translate }}
          </div>
        </div>
        <div v-else>
          <div
            v-for="task in stage.tasks"
            :key="roadmapDefinition + task._id"
            @click="openTaskDetail(task._id)"
            :class="task.status == 'DONE' ? 'done' : ''"
            class="rm--task mb-1 hand"
            v-b-tooltip.hover
            :title="taskInfo(task)"
          >
            <i v-if="task.status == 'DONE'" class="iconoir-check-circle"></i>
            <i v-else-if="task.status == 'NOT_FIT'" class="iconoir-warning-circle"></i>
            <i v-else class="iconoir-circle"></i>
            {{ task.name | translate }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="lines && lines.includes('right')" class="line right"></div>
    <div v-if="lines && lines.includes('center')" class="line center"></div>
    <div v-if="lines && lines.includes('left')" class="line left"></div> -->
  </div>
</template>

<script>
import RadialProgressBar from "vue-radial-progress";

const state = "organizationRoadmap";

export default {
  props: ["roadmapDefinition", "definition", "title", "lines", "customStyle"],
  components: { RadialProgressBar },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    totalStepsCount() {
      if (!this.stage) return 0;
      return this.stage.tasks?.length ?? 0;
    },
    completedStepsCount() {
      if (!this.stage) return 0;
      return this.stage.tasks?.filter((t) => t.status == "DONE" || t.status == "NOT_FIT")?.length ?? 0;
    },
    stages() {
      return this.$store.getters[`${state}/stages`];
    },
    stage() {
      return this.stages.find((i) => i.definition == this.definition);
    },
    stageClass() {
      if (!this.stage) {
        return "unavailable";
      }
      if (this.stage.status == "STARTED") {
        return "active";
      }
      if (this.stage.status == "COMPLETED") {
        return "done";
      }
      if (this.stage.status == "NOT_STARTED") {
        return "not-started";
      }
      if (this.stage.status == "UNAVAILABLE") {
        return "unavailable";
      }
    },
  },

  mounted() {
    this.loadStage();
  },
  methods: {
    async loadStage() {
      try {
        this.isLoading = true;
        await this.$store.dispatch(`${state}/loadStage`, { roadmap: this.roadmapDefinition, stage: this.definition });
      } finally {
        this.isLoading = false;
      }
    },
    openTaskDetail(id) {
      this.$store.commit("task/showTaskDetailModal", true);
      this.$store.dispatch("task/fetchDetail", id);
    },
    taskInfo(task) {
      if (task.status == "IN_PROGRESS") {
        return this.$t("task.status.in-progress");
      } else if (task.status == "DONE") {
        return this.$t("task.status.done");
      } else if (task.status == "UNWORKED") {
        return this.$t("task.status.unworked");
      } else if (task.status == "NOT_FIT") {
        return this.$t("task.status.not-fit");
      } else if (task.status == "APPROVAL") {
        return this.$t("task.status.approval");
      }
      return this.$t("task.status.todo");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../roadmap";
</style>
